/**
 * This enumeration is used to configure whether the date/time picker has an editable input with drop down
 * or is readonly - the date/time is selected only through a dialog.
 */
export enum InteractionMode {
    DropDown = 'dropdown',
    Dialog = 'dialog'
}
